import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Pending = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isArabic = i18n.language === 'ar';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 px-4" dir={isArabic ? 'rtl' : 'ltr'}>
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center border-2 border-blue-500">
          <div className="mb-6">
            <div className="mx-auto w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center border-2 border-blue-500">
              <svg className="w-10 h-10 text-[#3B82F6]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            {t('accountPending')}
          </h1>

          <p className="text-gray-700 mb-8">
            {t('accountPendingMessage')}
          </p>

          <button
            onClick={() => navigate('/login')}
            className="w-full bg-blue-500 text-black py-3 rounded-lg font-bold hover:bg-blue-600 transition-colors shadow-md"
          >
            {t('login')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pending;